<template>
    <div class="foot">
      <div class="box">
        <div class="menuBox">
            <div class="title">{{i18n.foot.navigation}}</div>
            <div class="menuList">
                <div class="menu cursor textHover" v-for="(item,index) in $store.state.menuData" :key="index">
                    <div class="icon">
                        <img src="../assets/foot/right.png" alt="">
                    </div>
                    <p>
                        <router-link :to="item.link">
                            {{item.name}}
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="menuBox">
            <div class="title">{{i18n.foot.type}}</div>
            <div class="menuList">
                <div class="menu cursor textHover" v-for="(item,index) in $store.state.typeList" :key="index">
                    <div class="icon">
                        <img src="../assets/foot/right.png" alt="">
                    </div>
                    <p>
                        <router-link :to="item.link">
                            {{item.name}}
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="menuBox menuBoxH">
            <div class="title" style="visibility: hidden;">{{i18n.foot.type}}</div>
            <div class="setBox" style="margin-top: 0;">
                <div class="setList">
                    <div class="icon">
                        <img src="../assets/foot/phone.png" alt="">
                    </div>
                    <div class="right">
                        <p>{{i18n.foot.mobile}}</p>
                        <p class="cursor textHover" v-for="(item,index) in $store.state.navInfo.Tel" :key="index">
                            <a v-for="(e,i) in (api.strToarr(item))" :key="i" :href="'tel:' + e" class="clicka" style="display: block;">{{e}}</a>
                        </p>
                    </div>
                </div>
                <div class="setList">
                    <div class="icon">
                        <img src="../assets/foot/emil.png" alt="">
                    </div>
                    <div class="right">
                        <p>{{i18n.foot.email}}</p>
                        <p class="cursor textHover" v-for="(item,index) in $store.state.navInfo.Email" :key="index">
                            <a :href="'mailto:' + item" target="_blank" class="clicka">{{item}}</a><br>
                        </p>
                    </div>
                </div>
                <div class="setList">
                    <div class="icon">
                        <img src="../assets/foot/address.png" alt="">
                    </div>
                    <div class="right">
                        <p>{{i18n.foot.address}}</p>
                        <!-- Huafu Commercial Center, Wenfeng District, Anyang City, Henanprovince, China -->
                        <p class="cursor textHover">Longquan Town, Anyang City, Henan Province</p>
                    </div>
                </div>
            </div>
            <div class="gongBox">
                <div class="gong listHover3">
                    <img src="../assets/product/13.png" alt="">
                </div>
                <div class="gong listHover3">
                    <img src="../assets/product/14.png" alt="">
                </div>
                <div class="gong listHover3">
                    <img src="../assets/product/15.png" alt="">
                </div>
                <div class="gong listHover3">
                    <img src="../assets/product/16.png" alt="">
                </div>
            </div>
        </div>
        <div class="logoCon">
            <div class="logoBox">
                <div class="logo">
                    <img src="../assets/foot/logo.png" alt="">
                </div>
                <div class="logoText">
                    <!-- <p>QRF ALLOY MANUFACTURER</p>
                    <p>Henan Qingrongfa metal material Co. LTD</p> -->
                    <img src="../assets/textlogo.png"alt="">
                </div>
            </div>
            <div class="desc">{{i18n.foot.service}}</div>
            <div class="erBox">
                <div class="pic" v-for="(item,index) in $store.state.qrcode" :key="index">
                    <img :src="$store.state.imgurl + item" alt="">
                </div>
            </div>
            <div class="emialBox">
                <div class="fromBox">
                    <div class="list" style="width: 100%;">
                        <input type="text" :placeholder="i18n.service.name" v-model="name">
                    </div>
                    <div class="listT">
                        <div class="list">
                            <input type="text" :placeholder="i18n.service.mail" v-model="mail">
                        </div>
                        <div class="list">
                            <input type="text" :placeholder="i18n.service.tel" v-model="tel">
                        </div>
                    </div>
                    <div class="textBox">
                        <textarea :placeholder="i18n.btn.text6" v-model="text"></textarea>
                    </div>
                    <div class="btnBox">
                        <div class="btn btnHover2" @click="postEmail">{{i18n.btn.submit}}</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="number">
        <p class="textHover">{{i18n.foot.number}}：0231-123452341346546578</p>
      </div>
    </div>
  </template>
   
  <script>
  
  export default {
    name: "footBox",
    components: {},
    data() {
      return {
        name:'',
        mail:'',
        text:'',
        tel:''
      };
    },
    props:{
       
    },
    watch: {},
    computed: {
      i18n() {
          return this.$t("message");
      },
    },
    methods: {
      // 提交
      postEmail(){
            if(!this.mail){
                this.$message({
                    message: this.i18n.product.ti1,
                    type: 'warning'
                });
                return
            }
            if(!this.text){
                this.$message({
                    message: this.i18n.product.ti3,
                    type: 'warning'
                });
                return
            }
            let data = {
                name:this.name,
                elmail:this.mail,
                text:this.text,
                tel:this.tel
            }
            this.$postRequest("/Leave/save",data).then((res) => {
                if(res.code == 200){
                    this.name = '';
                    this.mail = '';
                    this.text = '';
                    this.tel = '';
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                }
            });
        }
    },
    beforeCreate() {},
    created() {
      
    },
    destroyed() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    activated() {},
    deactivated() {},
  };
  </script>
  <style lang="less" scoped>
  .foot{
    padding: 40px 260px 0;
    // background: #222222;
    background-image: url('../assets/foot.png');
    background-size: 100% 100%;
    .box{
        display: flex;
        justify-content: space-between;
    }
  }
  .menuBox{
    flex-shrink: 0;
    max-width: 400px;
    .title{
        font-size: 28px;
        color: #FFFFFF;
    }
    .menuList{
        margin-top: 20px;
        .menu{
            display: flex;
            align-items: center;
            color: #B6B6B6;
            font-size: 22px;
            margin-bottom: 20px;
            &:nth-last-child(1){
                margin-bottom: 0;
            }
            .icon{
                width: 16px;
                height: 16px; 
                margin-right: 10px;
                img{
                    width: 16px;
                    height: 16px; 
                }
            }
            a{
                color: #B6B6B6;
                font-size: 22px;
            }
        }
    }
  }
  .setBox{
    margin-top: 20px;
    .setList{
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        &:nth-last-child(1){
            margin-bottom: 0;
        }
        .icon{
            width: 32px;
            height: 32px;
            margin-right: 15px;
            img{
                width: 32px;
                height: 32px;
            }
        }
        .right{
            p{
                color: #B6B6B6;
                font-size: 22px;
                margin-top: 9px;
                &:nth-child(1){
                    color: #D4D4D4;
                    font-size: 22px;
                }
                a{
                    color: #D4D4D4;
                    font-size: 22px;
                }
            }
        }
    }
  }
  .gongBox{
    display: flex;
    align-items: center;
    margin-top: 37px;
    .gong{
        width: 50px;
        height: 50px;
        margin-right: 17px;
        img{
            width: 50px;
            height: 50px;
        }
    }
  }
  .logoCon{
    flex-shrink: 0;
    .logoBox{
        display: flex;
        align-items: center;
        .logo{
            width: 60px;
            height: 60px;
            margin-right: 10px;
            img{
                width: 60px;
                height: 60px;
            }
        }
        .logoText{
           p:nth-child(1){
            color: #FFFFFF;
            font-size: 21px;
            font-weight: bold;
           }
           p:nth-child(2){
            color: #FFFFFF;
            font-size: 15px;
           }
           img{
                width: 190px;
                height: auto;
           }
        }
    }
    .desc{
        margin-top: 17px;
        color: #FFFFFF;
        font-size: 22px;
    }
    .erBox{
        margin-top: 33px;
        display: flex;
       .pic{
            width: 120px;
            height: 120px;
            &:nth-child(1){
                margin-right: 28px;
            }
            img{
                width: 120px;
                height: 120px;
            }
       } 
    }
    .emialBox{
        width: 400px;
        margin: 0 auto;
        .fromBox{
            width: 100%;
        }
        .listT{
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
        .list{
            width: 48%;
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            input{
                width: 100%;
                height: 40px;
                border-bottom: 1px solid #666666;
                font-size: 22px;
                color: rgba(255,255,255,0.6);
                background: none;
            }
            input::placeholder{
                font-size: 22px;
                color: rgba(255,255,255,0.6);
            }
        }
        .textBox{
            textarea{
                padding: 15px 0;
                width: 100%;
                height: 80px;
                border: none;
                border-bottom: 1px solid #666666;
                font-size: 22px;
                color: rgba(255,255,255,0.6);
                outline: none;
                background: none;
            }
            textarea::placeholder{
                font-size: 22px;
                color: rgba(255,255,255,0.6);
            }
        }
        .btnBox{
            display: flex;
            justify-content: flex-end;
        }
        .btn{
            padding: 10px 30px;
            background: rgba(255, 255, 255, 0.45);
            color: rgba(255,255,255,.8);
            font-size: 22px;
            display: inline-block;
            margin-top: 26px;
        }
    }
  }
  .number{
    margin-top: 45px;
    border-top: 1px solid #414141;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #B6B6B6;
    font-size: 22px;
  }
  @media screen and (max-width: 1600px){
    .foot{
        padding: 40px 60px 100px;
    }
    .box{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .logoCon{
        flex-shrink: 0;
        margin: 30px auto 0;
    }
  }
  @media screen and (max-width: 768px) {
    .foot{
        padding: 40px 30px 100px;
        background-size: 100% 100%;
        
    }
    .menuBox{
        flex-shrink: 0;
        max-width: auto;
        width: 50%;
        margin-bottom: 40px;
        .title{
            font-size: 30px;
            color: #FFFFFF;
        }
        .menuList{
            margin-top: 20px;
            .menu{
                display: flex;
                align-items: center;
                color: #B6B6B6;
                margin-bottom: 20px;
                a{
                    font-size: 24px;
                }
                &:nth-last-child(1){
                    margin-bottom: 0;
                }
                .icon{
                    width: 24px;
                    height: 24px; 
                    margin-right: 10px;
                    img{
                        width: 24px;
                        height: 24px; 
                    }
                }
            }
        }
    }
    .menuBoxH{
        max-width: 100% !important;
        flex: 1;
    }
    .setBox{
        margin-top: 20px;
        width: 100% !important;
        .setList{
            display: flex;
            align-items: center;
            margin-bottom: 25px;
            &:nth-last-child(1){
                margin-bottom: 0;
            }
            .icon{
                width: 45px;
                height: 45px;
                margin-right: 15px;
                img{
                    width: 45px;
                    height: 45px;
                }
            }
            .right{
                p{
                    color: #B6B6B6;
                    font-size: 24px;
                    margin-top: 9px;
                    &:nth-child(1){
                        color: #D4D4D4;
                        font-size: 24px;
                    }
                }
                a{
                    color: #D4D4D4 !important;
                    font-size: 24px !important;
                }
            }
        }
    }
    .gongBox{
        display: flex;
        align-items: center;
        margin-top: 37px;
        .gong{
            width: 60px;
            height: 60px;
            margin-right: 17px;
            img{
                width: 60px;
                height: 60px;
            }
        }
    }
    .logoCon{
        flex-shrink: 0;
        margin: 0 auto;
        .logoBox{
            display: flex;
            align-items: center;
            justify-content: center;
            .logo{
                width: 90px;
                height: 90px;
                margin-right: 10px;
                img{
                    width: 90px;
                    height: 90px;
                }
            }
            .logoText{
                img{
                    width: 150px;
                    height: auto;
                }
            p:nth-child(1){
                color: #FFFFFF;
                font-size: 28px;
                font-weight: bold;
            }
            p:nth-child(2){
                color: #FFFFFF;
                font-size: 24px;
            }
            }
        }
        .desc{
            margin-top: 17px;
            color: #FFFFFF;
            font-size: 24px;
            text-align: center;
        }
        .erBox{
            margin-top: 33px;
            display: flex;
            justify-content: center;
        .pic{
                width: 165px;
                height: 165px;
                &:nth-child(1){
                    margin-right: 28px;
                }
                img{
                    width: 165px;
                    height: 165px;
                }
        } 
        }
    }
    .number{
        margin-top: 45px;
        border-top: 1px solid #414141;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #B6B6B6;
        font-size: 24px;
    }
  }
  </style>